import { render } from "./PerkNPSDelivery.vue?vue&type=template&id=518b0f4c&scoped=true"
import script from "./PerkNPSDelivery.vue?vue&type=script&lang=js"
export * from "./PerkNPSDelivery.vue?vue&type=script&lang=js"

import "./PerkNPSDelivery.vue?vue&type=style&index=0&id=518b0f4c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-518b0f4c"]])

export default __exports__